export enum AnalysisCalculateTotalTypeVariable {
  TotalBalance = "TotalBalance",
  IDPSTotal = "IDPSTotal",
  SuperTotal = "SuperTotal",
  TotalAccounts = "TotalAccounts",
}
